export const AGENT_AUTH_HEADERS = {
  auth: "X-Agent-Auth",
  email: "X-Agent-Email",
  superuser: "X-Agent-Superuser",
} as const;

type AgentAuthEnv = {
  PROD?: boolean;
  MODE?: string;
  VITE_AGENT_AUTH_ENABLED?: string;
  VITE_AGENT_AUTH_EMAIL?: string;
  VITE_AGENT_AUTH_SUPERUSER?: string;
};

const DEFAULT_AGENT_EMAIL = "agent.admin@example.com";

const enabled = (value?: string) =>
  ["1", "true", "yes", "on"].includes((value ?? "").trim().toLowerCase());

export const getAgentAuthHeaders = (
  env: AgentAuthEnv = import.meta.env
): Record<string, string> => {
  if (env.PROD || env.MODE === "production") {
    return {};
  }

  if (!enabled(env.VITE_AGENT_AUTH_ENABLED)) {
    return {};
  }

  const email = env.VITE_AGENT_AUTH_EMAIL?.trim() || DEFAULT_AGENT_EMAIL;
  const headers: Record<string, string> = {
    [AGENT_AUTH_HEADERS.auth]: "true",
    [AGENT_AUTH_HEADERS.email]: email,
  };

  if (enabled(env.VITE_AGENT_AUTH_SUPERUSER)) {
    headers[AGENT_AUTH_HEADERS.superuser] = "true";
  }

  return headers;
};
